export class TreeNodeTag {
  constructor(
    readonly identifier: string,
    readonly name: string,
  ) {}
}

export const finalScreeNodeTag = new TreeNodeTag('global:final', 'Final');
